import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MDArtistBodyModel } from 'src/app/model/MDArtistBodyModel';
import { RegistrationModerationDocumentModel } from 'src/app/model/RegistrationModerationDocumentModel';

@Component({
  selector: 'app-secure-md-artist',
  templateUrl: './md-artist.component.html',
  styleUrls: []
})
export class MDArtistComponent implements OnInit {
  @Input() registrationModerationDocument: RegistrationModerationDocumentModel;
  verifyForm: FormGroup = new FormGroup({});
  isVerifyDisabled: boolean;
  verifyErrorMessage: string;
  @Output() onSubmit = new EventEmitter<MDArtistBodyModel>();
  departments: string[] = [];

  constructor() { }

  ngOnInit(): void { 
    console.log(this.registrationModerationDocument);
    this.verifyForm = new FormGroup({
      nameAsOnCertificate: new FormControl(null, [Validators.required]),
      isStampReadable: new FormControl(null, [Validators.required]),
      isStampFromRKS: new FormControl(null, [Validators.required]),
      isSignaturePresent: new FormControl(null, [Validators.required]),
      isDateOfIssuePresent: new FormControl(null, [Validators.required]),
      // isQRCodePresent: new FormControl(null, [Validators.required]),
    });
  }

  onSubmitVerify() {
    console.log('verify submit clicked', this.verifyForm);
    this.verifyErrorMessage = null;
    if (this.verifyForm.valid) {
      this.onSubmit.emit(new MDArtistBodyModel(
        this.verifyForm.value.nameAsOnCertificate,
        this.verifyForm.value.isStampReadable,
        this.verifyForm.value.isStampFromRKS,
        this.verifyForm.value.isSignaturePresent,
        this.verifyForm.value.isDateOfIssuePresent,
        // this.verifyForm.value.isQRCodePresent
        ));
    }
    else {
      this.verifyErrorMessage = "Please enter all mandatory fields";
      this.isVerifyDisabled = false;
    }
  }
}
